<template>
  <div class="sidebar">
    <SidebarLogoMenu />
    <SidebarActionMenu />
    <SidebarMainMenu />
    <UserOptions />
  </div>
</template>

<script>
import router from '@/router'
import UserOptions from '@/components/userOptions/UserOptions'
import SidebarActionMenu from './sidebar/SidebarActionMenu'
import SidebarMainMenu from './sidebar/SidebarMainMenu'
import SidebarLogoMenu from './sidebar/SidebarLogoMenu'

export default {
  name: 'Sidebar',

  components: {
    UserOptions,
    SidebarActionMenu,
    SidebarMainMenu,
    SidebarLogoMenu,
  },
}
</script>
